<template>
  <div class="delegated-company">
    <el-card shadow="never">
      <div slot="header" class="card-header">
        <span>可委托公司管理</span>
        <el-button type="primary" size="small" icon="el-icon-plus" @click="handleCreate">添加委托公司</el-button>
      </div>

      <el-table :data="list" border stripe v-loading="loading" style="width: 100%">
        <el-table-column prop="id" label="ID" width="70" />
        <el-table-column prop="company_name" label="公司全称" min-width="220" />
        <el-table-column prop="wechat_merchant_no" label="微信商户号" width="160" />
        <el-table-column prop="profit_sharing_name" label="分账接收方名称" width="180">
          <template slot-scope="scope">{{ scope.row.profit_sharing_name || '-' }}</template>
        </el-table-column>
        <el-table-column prop="remark" label="备注" min-width="160">
          <template slot-scope="scope">{{ scope.row.remark || '-' }}</template>
        </el-table-column>
        <el-table-column label="状态" width="90">
          <template slot-scope="scope">
            <el-switch
              :value="scope.row.status === 1"
              @change="val => handleToggleStatus(scope.row, val)"
            />
          </template>
        </el-table-column>
        <el-table-column prop="created_at" label="创建时间" width="170" />
        <el-table-column label="操作" width="140" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="handleEdit(scope.row)">编辑</el-button>
            <el-button type="text" size="small" style="color: #E4393C" @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination-wrap" v-if="total > 0">
        <el-pagination
          background
          layout="total, prev, pager, next"
          :total="total"
          :page-size="query.limit"
          :current-page.sync="query.page"
          @current-change="getList"
        />
      </div>
    </el-card>

    <!-- 添加/编辑对话框 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="560px" :close-on-click-modal="false">
      <el-form ref="form" :model="form" :rules="rules" label-width="120px">
        <el-form-item label="公司全称" prop="company_name">
          <el-input v-model="form.company_name" placeholder="请输入公司全称" maxlength="200" />
        </el-form-item>
        <el-form-item label="微信商户号" prop="wechat_merchant_no">
          <el-input v-model="form.wechat_merchant_no" placeholder="请输入微信商户号" maxlength="50" />
        </el-form-item>
        <el-form-item label="商户密钥" prop="wechat_merchant_secret">
          <el-input v-model="form.wechat_merchant_secret" type="textarea" :rows="2" placeholder="请输入微信商户密钥（API密钥）" />
        </el-form-item>
        <el-form-item label="分账接收方名称">
          <el-input v-model="form.profit_sharing_name" placeholder="微信分账接收方名称（对应公司全称）" maxlength="64" />
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="form.remark" type="textarea" :rows="2" placeholder="备注说明" maxlength="500" />
        </el-form-item>
        <el-form-item label="状态">
          <el-radio-group v-model="form.status">
            <el-radio :label="1">启用</el-radio>
            <el-radio :label="0">停用</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="submitLoading" @click="handleSubmit">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getDelegatedCompanies, createDelegatedCompany, updateDelegatedCompany, toggleDelegatedCompany, deleteDelegatedCompany } from '@/api'

export default {
  name: 'DelegatedCompany',
  data() {
    return {
      loading: false,
      list: [],
      total: 0,
      query: { page: 1, limit: 15 },
      dialogVisible: false,
      dialogTitle: '',
      isEdit: false,
      editId: null,
      submitLoading: false,
      form: {
        company_name: '',
        wechat_merchant_no: '',
        wechat_merchant_secret: '',
        profit_sharing_name: '',
        remark: '',
        status: 1
      },
      rules: {
        company_name: [{ required: true, message: '请输入公司全称', trigger: 'blur' }],
        wechat_merchant_no: [{ required: true, message: '请输入微信商户号', trigger: 'blur' }],
        wechat_merchant_secret: [{ required: true, message: '请输入商户密钥', trigger: 'blur' }]
      }
    }
  },
  created() {
    this.getList()
  },
  methods: {
    getList() {
      this.loading = true
      getDelegatedCompanies(this.query).then(res => {
        this.list = res.data || []
        this.total = res.total || 0
      }).catch(() => {
        this.$message.error('获取列表失败')
      }).finally(() => { this.loading = false })
    },
    resetForm() {
      this.form = {
        company_name: '',
        wechat_merchant_no: '',
        wechat_merchant_secret: '',
        profit_sharing_name: '',
        remark: '',
        status: 1
      }
    },
    handleCreate() {
      this.isEdit = false
      this.editId = null
      this.dialogTitle = '添加委托公司'
      this.resetForm()
      this.dialogVisible = true
      this.$nextTick(() => this.$refs.form && this.$refs.form.clearValidate())
    },
    handleEdit(row) {
      this.isEdit = true
      this.editId = row.id
      this.dialogTitle = '编辑委托公司'
      this.form = {
        company_name: row.company_name,
        wechat_merchant_no: row.wechat_merchant_no,
        wechat_merchant_secret: '',
        profit_sharing_name: row.profit_sharing_name || '',
        remark: row.remark || '',
        status: row.status
      }
      this.dialogVisible = true
      this.$nextTick(() => this.$refs.form && this.$refs.form.clearValidate())
    },
    handleSubmit() {
      this.$refs.form.validate(valid => {
        if (!valid) return
        this.submitLoading = true
        const data = { ...this.form }
        if (this.isEdit) data.id = this.editId

        const apiCall = this.isEdit ? updateDelegatedCompany(data) : createDelegatedCompany(data)

        apiCall.then(() => {
          this.$message.success(this.isEdit ? '更新成功' : '创建成功')
          this.dialogVisible = false
          this.getList()
        }).catch(err => {
          this.$message.error(err.message || '操作失败')
        }).finally(() => { this.submitLoading = false })
      })
    },
    handleToggleStatus(row, val) {
      toggleDelegatedCompany({ id: row.id, status: val ? 1 : 0 }).then(() => {
        this.$message.success(val ? '已启用' : '已停用')
        this.getList()
      }).catch(() => {
        this.$message.error('操作失败')
        this.getList()
      })
    },
    handleDelete(row) {
      this.$confirm(`确认删除委托公司 "${row.company_name}"？`, '提示', { type: 'warning' }).then(() => {
        deleteDelegatedCompany({ id: row.id }).then(() => {
          this.$message.success('删除成功')
          this.getList()
        })
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.pagination-wrap {
  margin-top: 16px;
  text-align: right;
}
</style>
